/**
 * Modal Module
 * Modal/dialog functionality
 */

const Modal = {
    activeModal: null,
    focusableElements: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',

    init() {
        this.bindEvents();
    },

    bindEvents() {
        // Open modal triggers
        document.addEventListener('click', (e) => {
            const trigger = e.target.closest('[data-modal-open]');
            if (trigger) {
                e.preventDefault();
                const modalId = trigger.getAttribute('data-modal-open');
                this.open(modalId);
            }
        });

        // Close modal triggers
        document.addEventListener('click', (e) => {
            if (e.target.matches('[data-modal-close], .modal__overlay')) {
                e.preventDefault();
                this.close();
            }
        });

        // Close on escape
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.activeModal) {
                this.close();
            }
        });
    },

    open(modalId) {
        const modal = document.getElementById(modalId);
        if (!modal) return;

        this.activeModal = modal;
        modal.classList.add('is-active');
        document.body.classList.add('modal-open');

        // Focus first focusable element
        const focusable = modal.querySelectorAll(this.focusableElements);
        if (focusable.length) {
            focusable[0].focus();
        }

        // Store last focused element
        this.lastFocused = document.activeElement;

        // Trap focus
        this.trapFocus(modal);

        // Emit event
        modal.dispatchEvent(new CustomEvent('modal:open'));
    },

    close() {
        if (!this.activeModal) return;

        this.activeModal.classList.remove('is-active');
        document.body.classList.remove('modal-open');

        // Restore focus
        if (this.lastFocused) {
            this.lastFocused.focus();
        }

        // Emit event
        this.activeModal.dispatchEvent(new CustomEvent('modal:close'));
        
        this.activeModal = null;
    },

    trapFocus(modal) {
        const focusable = modal.querySelectorAll(this.focusableElements);
        const firstFocusable = focusable[0];
        const lastFocusable = focusable[focusable.length - 1];

        modal.addEventListener('keydown', (e) => {
            if (e.key !== 'Tab') return;

            if (e.shiftKey) {
                if (document.activeElement === firstFocusable) {
                    lastFocusable.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusable) {
                    firstFocusable.focus();
                    e.preventDefault();
                }
            }
        });
    }
};

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    Modal.init();
});

// Make available globally
window.CMModal = Modal;

export default Modal;
